import { Center } from "@mantine/core";
import { useForm } from "@mantine/form";
import { Button, Modal, Text, TextInput } from "components";
import { IRootState } from "config/redux";
import { ServiceConstants } from "constant";
import { TFunction } from "i18next";
import { useCallback, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { CreditService } from "services";
import { AppUtils } from "utils";

const { REQUEST_CREDIT_ATTACHMENT_TYPE_NEW_ID, REQUEST_PENDING } = ServiceConstants;

interface AttachmentTypeCreateModalProps {
  creditId: number;
  opened: boolean;
  onClose: () => void;
  t: TFunction;
}

const AttachmentTypeCreateModal = ({ creditId, opened, onClose, t }: AttachmentTypeCreateModalProps) => {
  const createServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CREDIT_ATTACHMENT_TYPE_NEW_ID]);

  useEffect(() => {
    if (!opened) form.reset();
  }, [opened]);

  const createAttachmentType = useCallback(() => CreditService.creditAttachmentTypeCreate(creditId, form.getTransformedValues().name), [creditId]);
  const isLoading = useMemo(() => createServiceObject && createServiceObject.status === REQUEST_PENDING, [createServiceObject]);

  const form = useForm({
    initialValues: {
      name: ''
    },
    validate: {
      name: (value: string) => AppUtils.isEmpty(value) ? t('error.required') : null
    }
  })

  return (
    <Modal opened={opened} onClose={onClose} title={t('credit.documentation.required.new.title')}>
      <TextInput
        label={t('credit.documentation.name')}
        key={form.key('name')}
        {...form.getInputProps('name')}
      />
      <Center mt={32}>
        <Button
          onClick={createAttachmentType}
          disabled={isLoading || !form.isDirty() || !form.isValid()}
          loading={isLoading}
        >
          <Text>{t('action.submit')}</Text>
        </Button>
      </Center>
    </Modal>
  )
}

export default AttachmentTypeCreateModal;